import React, { useState } from 'react'

import { useStyles } from '..'
import styles from './jss/tooltip'

import clsx from 'clsx'

export const Tooltip = ({ descricao, isLast, className, onClick, pointer }) => {
    const classes = useStyles(styles)

    const [showDescription, setDescription] = useState(false)

    const tooltipStyle = clsx({
        [classes.tooltip]: true,
        [classes.pointer]: pointer
    })

    const descriptionStyle = clsx({
        [classes.description]: true,
        [classes.showDescription]: showDescription,
        [classes.isLast]: isLast
    })

    return (
        <div
            className={`${tooltipStyle} ${className}`}
            onMouseEnter={() => setDescription(true)}
            onMouseLeave={() => setDescription(false)}
            onClick={onClick}
        >
            {Boolean(descricao) && <div className={descriptionStyle}>{descricao}</div>}
        </div>
    )
}

Tooltip.defaultProps = {
    className: '',
    badgeStyle: '',
    onClick: () => { },
    pointer: false
}

export default Tooltip